import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import useTitle from '../../../hooks/useTitle';

export default function DataProtection() {
  useTitle('Datenschutz');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 94px)',
        alignItems: 'center',
        maxWidth: '80%',
        width: '700px',
        py: '100px',
      }}
    >
      <Box>
        <Typography variant="h1" sx={{ mt: '14px', fontSize: '36px' }}>
          Datenschutzerklärung
        </Typography>

        <Typography variant="h2" sx={{ mt: '14px', fontSize: '28px' }}>
          1. Datenschutz auf einen Blick
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Allgemeine Hinweise
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was
          mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
          besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
          persönlich identifiziert werden können. Ausführliche Informationen zum
          Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten
          Datenschutzerklärung.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Datenerfassung auf dieser Website
        </Typography>

        <Typography
          variant="h4"
          sx={{ mt: '14px', fontSize: '16px', fontWeight: 'bold' }}
        >
          Wer ist verantwortlich für die Datenerfassung auf dieser Website?
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die Datenverarbeitung auf dieser Website erfolgt durch den
          Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
          „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung
          entnehmen.
        </Typography>

        <Typography
          variant="h4"
          sx={{ mt: '14px', fontSize: '16px', fontWeight: 'bold' }}
        >
          Wie erfassen wir Ihre Daten?
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
          mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein
          Kontaktformular eingeben.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Andere Daten werden automatisch oder nach Ihrer Einwilligung beim
          Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem
          technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit
          des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch,
          sobald Sie diese Website betreten.
        </Typography>

        <Typography
          variant="h4"
          sx={{ mt: '14px', fontSize: '16px', fontWeight: 'bold' }}
        >
          Wofür nutzen wir Ihre Daten?
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung
          der Website zu gewährleisten. Andere Daten können zur Analyse Ihres
          Nutzerverhaltens verwendet werden. Sofern über die Website Verträge
          geschlossen oder angebahnt werden können, werden die übermittelten
          Daten auch für Vertragsangebote, Bestellungen oder sonstige
          Auftragsanfragen verarbeitet.
        </Typography>

        <Typography
          variant="h4"
          sx={{ mt: '14px', fontSize: '16px', fontWeight: 'bold' }}
        >
          Welche Rechte haben Sie bezüglich Ihrer Daten?
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
          Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
          erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung
          dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
          Datenverarbeitung erteilt haben, können Sie diese Einwilligung
          jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht,
          unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich
          jederzeit an uns wenden.
        </Typography>

        <Typography variant="h2" sx={{ mt: '14px', fontSize: '28px' }}>
          2. Hosting
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Amazon Web Services (AWS)
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Anbieter ist die Amazon Web Services EMEA SARL, 38 Avenue John F.
          Kennedy, 1855 Luxemburg (nachfolgend AWS).
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wenn Sie unsere Website besuchen, werden Ihre personenbezogenen Daten
          auf den Servern von AWS verarbeitet. Hierbei können auch
          personenbezogene Daten an das Mutterunternehmen von AWS in die USA
          übermittelt werden. Die Datenübertragung in die USA wird auf die
          EU-Standardvertragsklauseln gestützt. Details finden Sie hier:{' '}
          <Link
            to="https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/
          </Link>
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Weitere Informationen entnehmen Sie der Datenschutzerklärung von AWS:{' '}
          <Link
            to="https://aws.amazon.com/de/privacy/?nc1=f_pr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://aws.amazon.com/de/privacy/?nc1=f_pr
          </Link>
        </Typography>
        <Typography
          variant="h4"
          sx={{ mt: '14px', fontSize: '16px', fontWeight: 'bold' }}
        >
          Auftragsverarbeitung
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung
          des oben genannten Dienstes geschlossen. Hierbei handelt es sich um
          einen datenschutzrechtlich vorgeschriebenen Vertrag, der
          gewährleistet, dass dieser die personenbezogenen Daten unserer
          Websitebesucher nur nach unseren Weisungen und unter Einhaltung der
          DSGVO verarbeitet.
        </Typography>

        <Typography variant="h2" sx={{ mt: '14px', fontSize: '28px' }}>
          3. Allgemeine Hinweise und Pflichtinformationen
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Datenschutz
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
          sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
          entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wenn Sie diese Website benutzen, werden verschiedene personenbezogene
          Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie
          persönlich identifiziert werden können. Die vorliegende
          Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir
          sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das
          geschieht.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B.
          bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann.
          Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist
          nicht möglich.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Hinweis zur verantwortlichen Stelle
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser
          Website ist:
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Codemeta GmbH
          <br />
          Daimlerstr. 22a
          <br />
          54634 Bitburg
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Telefon: +49 6561 6994420
          <br />
          E-Mail: info@codemeta.de
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Verantwortliche Stelle ist die natürliche oder juristische Person, die
          allein oder gemeinsam mit anderen über die Zwecke und Mittel der
          Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen
          o. Ä.) entscheidet.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Speicherdauer
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Soweit innerhalb dieser Datenschutzerklärung keine speziellere
          Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten
          bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie
          ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung
          zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern
          wir keine anderen rechtlich zulässigen Gründe für die Speicherung
          Ihrer personenbezogenen Daten haben (z. B. steuer- oder
          handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall
          erfolgt die Löschung nach Fortfall dieser Gründe.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf
          dieser Website
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten
          wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit.
          a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere
          Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle
          einer ausdrücklichen Einwilligung in die Übertragung personenbezogener
          Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf
          Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die
          Speicherung von Cookies oder in den Zugriff auf Informationen in Ihr
          Endgerät (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt
          die Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG.
          Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur
          Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen
          erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs.
          1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese
          zur Erfüllung einer rechtlichen Verpflichtung erforderlich sind auf
          Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann
          ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs.
          1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen
          Rechtsgrundlagen wird in den folgenden Absätzen dieser
          Datenschutzerklärung informiert.
        </Typography>
        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Empfänger von personenbezogenen Daten
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen
          externen Stellen zusammen. Dabei ist teilweise auch eine Übermittlung
          von personenbezogenen Daten an diese externen Stellen erforderlich.
          Wir geben personenbezogene Daten nur dann an externe Stellen weiter,
          wenn dies im Rahmen einer Vertragserfüllung erforderlich ist, wenn wir
          gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von Daten an
          Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs.
          1 lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige
          Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
          Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden
          nur auf Grundlage eines gültigen Vertrags über Auftragsverarbeitung
          weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über
          gemeinsame Verarbeitung geschlossen.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Widerruf Ihrer Einwilligung zur Datenverarbeitung
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
          Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
          jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
          erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
          gegen Direktwerbung (Art. 21 DSGVO)
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER
          F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH
          AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER
          PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN
          AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE
          RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE
          DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR
          IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES
          SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE
          VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN
          ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG
          ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS.
          1 DSGVO).
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU
          BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE
          VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE
          DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING,
          SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE
          WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT
          MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21
          ABS. 2 DSGVO).
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Beschwerderecht bei der zuständigen Aufsichtsbehörde
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
          Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
          Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
          oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht
          besteht unbeschadet anderweitiger verwaltungsrechtlicher oder
          gerichtlicher Rechtsbehelfe.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Recht auf Datenübertragbarkeit
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
          oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich
          oder an einen Dritten in einem gängigen, maschinenlesbaren Format
          aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an
          einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es
          technisch machbar ist.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Auskunft, Berichtigung und Löschung
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
          das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
          personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck
          der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder
          Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
          personenbezogene Daten können Sie sich jederzeit an uns wenden.
        </Typography>
        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Recht auf Einschränkung der Verarbeitung
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit
          an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in
          folgenden Fällen:
        </Typography>
        <Typography component="ul" sx={{ mt: '14px', pl: '16px' }}>
          <Typography component="li" sx={{ mt: '14px' }}>
            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
            personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit,
            um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das
            Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen
            Daten zu verlangen.
          </Typography>
          <Typography component="li" sx={{ mt: '14px' }}>
            Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig
            geschah/geschieht, können Sie statt der Löschung die Einschränkung
            der Datenverarbeitung verlangen.
          </Typography>
          <Typography component="li" sx={{ mt: '14px' }}>
            Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie
            jedoch zur Ausübung, Verteidigung oder Geltendmachung von
            Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung
            die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen.
          </Typography>
          <Typography component="li" sx={{ mt: '14px' }}>
            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt
            haben, muss eine Abwägung zwischen Ihren und unseren Interessen
            vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
            überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung
            Ihrer personenbezogenen Daten zu verlangen.
          </Typography>
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt
          haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit
          Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung
          von Rechtsansprüchen oder zum Schutz der Rechte einer anderen
          natürlichen oder juristischen Person oder aus Gründen eines wichtigen
          öffentlichen Interesses der Europäischen Union oder eines
          Mitgliedstaats verarbeitet werden.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          SSL- bzw. TLS-Verschlüsselung
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
          Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder
          Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw.
          TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
          daran, dass die Adresszeile des Browsers von „http://“ auf „https://“
          wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
          Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
          werden.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Widerspruch gegen Werbe-E-Mails
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
          Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
          Werbung und Informationsmaterialien wird hiermit widersprochen. Die
          Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im
          Falle der unverlangten Zusendung von Werbeinformationen, etwa durch
          Spam-E-Mails, vor.
        </Typography>

        <Typography variant="h2" sx={{ mt: '14px', fontSize: '24px' }}>
          4. Datenerfassung auf dieser Website
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Server-Log-Dateien
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Der Provider der Seiten erhebt und speichert automatisch Informationen
          in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns
          übermittelt. Dies sind:
        </Typography>
        <Typography component="ul" sx={{ mt: '14px', pl: '16px' }}>
          <Typography component="li">Browsertyp und Browserversion</Typography>
          <Typography component="li">verwendetes Betriebssystem</Typography>
          <Typography component="li">Referrer URL</Typography>
          <Typography component="li">
            Hostname des zugreifenden Rechners
          </Typography>
          <Typography component="li">Uhrzeit der Serveranfrage</Typography>
          <Typography component="li">IP-Adresse</Typography>
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
          vorgenommen.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
          lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an
          der technisch fehlerfreien Darstellung und der Optimierung seiner
          Website – hierzu müssen die Server-Log-Files erfasst werden.
        </Typography>
        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Kontaktformular
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
          Angaben aus dem Anfrageformular inklusive der von Ihnen dort
          angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den
          Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir
          nicht ohne Ihre Einwilligung weiter.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
          lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
          zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
          erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf
          unserem berechtigten Interesse an der effektiven Bearbeitung der an
          uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt
          wurde; die Einwilligung ist jederzeit widerrufbar.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei
          uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
          Speicherung widerrufen oder der Zweck für die Datenspeicherung
          entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage).
          Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen
          – bleiben unberührt.
        </Typography>

        <Typography variant="h3" sx={{ mt: '14px', fontSize: '24px' }}>
          Anfrage per E-Mail, Telefon oder Telefax
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre
          Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten
          (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns
          gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre
          Einwilligung weiter.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
          lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
          zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
          erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf
          unserem berechtigten Interesse an der effektiven Bearbeitung der an
          uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt
          wurde; die Einwilligung ist jederzeit widerrufbar.
        </Typography>
        <Typography sx={{ mt: '14px' }}>
          Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben
          bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
          Speicherung widerrufen oder der Zweck für die Datenspeicherung
          entfällt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens).
          Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche
          Aufbewahrungsfristen – bleiben unberührt.
        </Typography>

        <Typography sx={{ mt: '14px' }}>
          Quelle:{' '}
          <Link
            to="https://www.e-recht24.de"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.e-recht24.de
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}
